<!--<a name="top"></a> -->
<div class="container" id="top">
  <h2>Cost Center</h2>
  <mfk-table highlight="cctr"></mfk-table>
</div>
<div class="container">
  <table cellpadding="3" border="0" width="100%" cellpadding="0" class="table" summary="Details relating to the Cost Center portion of the Master File Key.">
    <tbody>
      <tr>
        <th>Length:</th>
        <td>4 characters</td>
      </tr>
      <tr>
        <th>Description:</th>
        <td>The cost center element will be used to indicate if it is identifying building codes, faculty codes or open
          access numbers as described below.</td>
      </tr>
    </tbody>
  </table>
  <table cellpadding="3" border="0" width="100%" cellpadding="0" class="table" summary="Building Codes: 0001 - 0999">
    <thead>
      <tr>
        <th colspan="2">Building Codes: 0001 - 0999</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th class="vaTop">Description:</th>
        <td>
          This portion of the cost center element will be used by Central Administration to indicate the specific
          building
          code affected by a transaction. It is used to track building, other improvement and repair costs that will be
          capitalized or expensed.
        </td>
      </tr>
      <tr>
        <th class="vaTop">Required:</th>
        <td>
          Yes, for the following institutional accounts:
          <ul type="disc">
            <li>6260 Repair/Maintenance-Bldgs & Land Improvements</li>
            <li>6700 Land </li>
            <li>6710 Land Improvements</li>
            <li>6715 Infrastructure</li>
            <li>6720 Buildings </li>
          </ul>
        </td>
      </tr>
      <tr>
        <th class="vaTop">Restrictions:</th>
        <td>
          The space management and tracking division of Facilities Management notifies the Controller&apos;s Office-Capital Projects department
           when new GL cost centers need to be set up and when existing codes need to be inactivated in PSGL. The Capital Projects department makes these updates in PSGL.
        </td>
      </tr>
      <tr>
        <th class="vaTop">Default Value:</th>
        <td>This element always requires a valid building code.</td>
      </tr>
      <tr>
        <th class="vaTop">Example:</th>
        <td>0003 Chemistry-Botany Building</td>
      </tr>
    </tbody>
  </table>

  <table cellpadding="3" border="0" width="100%" cellpadding="0" class="table" summary="Faculty Codes: 1000 - 8999">
    <thead>
      <tr>
        <th colspan="2">
          Faculty Codes: 1000 - 8999 (Blocks assigned per Org Unit)
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th class="vaTop">Description:</th>
        <td>
          This portion of the cost center element will be used by organizational units or departments when they desire
          to
          track individual faculty codes for revenue and/or expense transactions. Individual faculty codes may be used
          accross multiple organizational units or departments.
        </td>
      </tr>
      <tr>
        <th class="vaTop">Required:</th>
        <td>Yes, if defined by the department; otherwise no.</td>
      </tr>
      <tr>
        <th class="vaTop">Restrictions:</th>
        <td>
          Accounting &amp; Financial Reporting must approve a new faculty code before adding it to the Chart of Values
          database.
        </td>
      </tr>
      <tr>
        <th>Default Value:</th>
        <td align="left" valign="top">0000</td>
      </tr>
    </tbody>
  </table>

  <table cellpadding="3" border="0" width="100%" cellpadding="0" class="table" summary="Faculty Codes: 1000 - 8999">
    <thead>
      <tr>
        <th colspan="2">Open Access Numbers: 9000 - 9999</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th class="vaTop">Description:</th>
        <td>
          This portion of the cost center element will be used by an organzational unit or department for any additional
          breakdown which may be necessary.
        </td>
      </tr>
      <tr>
        <th>Required:</th>
        <td>Yes, if defined by the department; otherwise no</td>
      </tr>
      <tr>
        <th>Restrictions:</th>
        <td>None</td>
      </tr>
    </tbody>
  </table>

</div>